import React from 'react';
import classes from './dashboard.module.css';
import { formatCount } from './dashboardFormat';

/** Trip-style card (booked / cancelled), aligned with zupptravelui TripStatCard. */
export const TripStatCard = ({ iconClass, title, booked, cancelled }) => (
  <div className={classes.StatCard}>
    <div className={classes.StatCardHead}>
      <div className={classes.StatIconWrap}>
        <i className={iconClass} aria-hidden="true" />
      </div>
      <div className={classes.StatTitle}>{title}</div>
    </div>
    <div className={classes.StatSplit}>
      <div className={classes.StatSplitCol}>
        <div className={classes.StatValue}>{formatCount(booked)}</div>
        <div className={classes.StatLabel}>Booked</div>
      </div>
      <div className={`${classes.StatSplitCol} ${classes.StatSplitColBorder}`}>
        <div className={`${classes.StatValue} ${cancelled > 0 ? classes.StatValueWarn : classes.StatValueMuted}`}>
          {formatCount(cancelled)}
        </div>
        <div className={classes.StatLabel}>Cancelled</div>
      </div>
    </div>
  </div>
);

/** Single-metric card for counts or currency strings. */
export const MetricStatCard = ({ iconClass, title, value, loading }) => (
  <div className={classes.StatCard}>
    <div className={classes.StatCardHead}>
      <div className={classes.StatIconWrap}>
        <i className={iconClass} aria-hidden="true" />
      </div>
      <div className={classes.StatTitle}>{title}</div>
    </div>
    <div className={classes.MetricBody}>
      <div className={classes.MetricValue}>{loading ? '…' : value}</div>
    </div>
  </div>
);
